import * as React from "react"
import * as DialogPrimitive from "@radix-ui/react-dialog"
import { Button } from "./button"

const Popconfirm = ({ title, description, onConfirm, onCancel, children }) => {
    const [open, setOpen] = React.useState(false);

    return (
        <DialogPrimitive.Root open={open} onOpenChange={setOpen}>
            <DialogPrimitive.Trigger asChild>
                {children}
            </DialogPrimitive.Trigger>
            <DialogPrimitive.Portal>
                <DialogPrimitive.Overlay className="fixed inset-0 bg-black bg-opacity-50" style={{ zIndex: 100 }} />
                <DialogPrimitive.Content className="fixed top-1/2 left-1/2 max-w-md transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-lg" style={{ zIndex: 100 }}>
                    <DialogPrimitive.Title className="text-lg font-medium">
                        {title}
                    </DialogPrimitive.Title>
                    <DialogPrimitive.Description className="mt-2 text-sm text-gray-500">
                        {description}
                    </DialogPrimitive.Description>
                    <div className="mt-4 flex justify-end space-x-2">
                        <Button
                            variant="outline"
                            onClick={() => {
                                setOpen(false);
                                if (onCancel) onCancel();
                            }}
                        >
                            取消
                        </Button>
                        <Button
                            onClick={() => {
                                setOpen(false);
                                if (onConfirm) onConfirm();
                            }}
                        >
                            確定
                        </Button>
                    </div>
                </DialogPrimitive.Content>
            </DialogPrimitive.Portal>
        </DialogPrimitive.Root>
    );
};

export { Popconfirm }
